import { NgModule } from "@angular/core";
import { SaysoSettingsComponent } from "@onsip/web/features/sayso/saysoSettings/sayso-settings.component";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    component: SaysoSettingsComponent
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class SaysoSettingsRoutingModule {}
